// extracted by mini-css-extract-plugin
module.exports = {"ContactData":"ContactData_ContactData__2Ag3a","Input":"ContactData_Input__1KR-K"};